var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Collapsible, Divider, InfoTag, Typography, getTestId, isLastItem, useBreakpoint, isValidObject, Tooltip, InfoIcon, BLUE_500, tokens } from '@airtel/air-design-system';
import { Pressable, View } from 'react-native';
import { getLeftRightListItemData, getPriceBreakupWidgetStyles } from '../../PriceBreakupWidgetStyles';
import { useState } from 'react';
export var PriceBreakupItem = props => {
  var leftDetails = props.leftDetails,
    onUserAction = props.onUserAction,
    isAccordian = props.isAccordian,
    accordianList = props.accordianList,
    rightDetails = props.rightDetails,
    showInfoTag = props.showInfoTag,
    infoTagProps = props.infoTagProps,
    subtext = props.subtext,
    containerStyle = props.containerStyle,
    multiSubTextList = props.multiSubTextList,
    multiText = props.multiText,
    isSubMultiText = props.isSubMultiText,
    showDivider = props.showDivider,
    leftTypographyStyle = props.leftTypographyStyle,
    rightTypographyStyle = props.rightTypographyStyle,
    _props$useWrappedText = props.useWrappedText,
    useWrappedText = _props$useWrappedText === void 0 ? false : _props$useWrappedText,
    testID = props.testID,
    _props$showInfoIcon = props.showInfoIcon,
    showInfoIcon = _props$showInfoIcon === void 0 ? false : _props$showInfoIcon,
    toolTipProps = props.toolTipProps,
    accessibilityProps = props.accessibilityProps,
    collapsibleProps = props.collapsibleProps,
    restProps = __rest(props, ["leftDetails", "onUserAction", "isAccordian", "accordianList", "rightDetails", "showInfoTag", "infoTagProps", "subtext", "containerStyle", "multiSubTextList", "multiText", "isSubMultiText", "showDivider", "leftTypographyStyle", "rightTypographyStyle", "useWrappedText", "testID", "showInfoIcon", "toolTipProps", "accessibilityProps", "collapsibleProps"]);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var priceBreakupItemStyles = getPriceBreakupWidgetStyles(props);
  var _useState = useState(false),
    showToolTip = _useState[0],
    setShowTooltip = _useState[1];
  var showAccordianView = isAccordian && (accordianList === null || accordianList === void 0 ? void 0 : accordianList.length) > 0;
  if (isValidObject(leftDetails)) {
    leftDetails.isBold = !!isAccordian || (leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.isBold);
  }
  if (isValidObject(rightDetails)) {
    rightDetails.isBold = !!isAccordian || (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.isBold);
  }
  var leftRightItemData = getLeftRightListItemData(props, isSmallScreen, useWrappedText);
  var onInfoIconPress = (iconPressMetaData, setShowTooltip, id) => {
    !iconPressMetaData && setShowTooltip(!showToolTip);
    iconPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, iconPressMetaData)));
  };
  var getContent = () => {
    var _a, _b;
    return _jsxs(View, Object.assign({
      style: priceBreakupItemStyles === null || priceBreakupItemStyles === void 0 ? void 0 : priceBreakupItemStyles.priceBreakUpitemWrapper
    }, {
      children: [_jsxs(View, Object.assign({
        style: [priceBreakupItemStyles.listContainer, showAccordianView ? priceBreakupItemStyles.collapsibleContainer : priceBreakupItemStyles.nonCollapsibleContainer, containerStyle]
      }, {
        children: [_jsxs(View, Object.assign({
          style: priceBreakupItemStyles.leftDetailsContainer
        }, {
          children: [_jsxs(View, Object.assign({
            style: priceBreakupItemStyles.leftDetailsItemContainer
          }, {
            children: [!!(leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.text) && _jsx(Typography, Object.assign({
              text: leftDetails.text,
              title: leftDetails.title,
              type: (leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.type) ? leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.type : leftRightItemData.leftItemFontType,
              color: (leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.color) ? leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.color : leftRightItemData.rightItemColor,
              style: leftTypographyStyle
            }, getTestId(testID, 'leftTitleText'))), !!showInfoIcon && (!!(toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.onInfoIconPressMetaData) || !!(toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.text)) && _jsx(Tooltip, Object.assign({
              text: (_a = toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.text) !== null && _a !== void 0 ? _a : '',
              position: "top-start",
              offset: {
                x: -10,
                y: -6
              },
              isVisible: showToolTip,
              onClose: () => {
                setShowTooltip(false);
              },
              style: priceBreakupItemStyles.infoIconTooltip,
              testID: (_b = toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.id) !== null && _b !== void 0 ? _b : 'InfoList-Child-RightToolTip',
              autoHide: true,
              autoHideTimeout: 5000
            }, toolTipProps, getTestId(testID, 'toolTip'), {
              children: _jsx(Pressable, Object.assign({
                onPress: () => onInfoIconPress(toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.onInfoIconPressMetaData, setShowTooltip, 'infoIconPress')
              }, {
                children: _jsx(InfoIcon, Object.assign({
                  color: BLUE_500,
                  fontSize: tokens.spacing.SPACING_16,
                  accessibilityLabel: "info icon"
                }, getTestId(testID, 'infoIcon')))
              }))
            }))]
          })), !!showInfoTag && _jsx(InfoTag, Object.assign({
            style: priceBreakupItemStyles.titleContentSpacer
          }, infoTagProps, getTestId(testID, 'infoTag'))), isSubMultiText ? !!multiText && _jsx(Typography, Object.assign({
            style: priceBreakupItemStyles.leftSubTextContainer,
            multiText: multiText,
            type: "body-para-xs",
            color: BLACK_700
          }, getTestId(testID, 'multiText'))) : !!subtext && _jsx(Typography, Object.assign({
            style: priceBreakupItemStyles.titleContentSpacer,
            text: subtext,
            type: "body-para-xs",
            color: BLACK_700
          }, getTestId(testID, 'subText')))]
        })), _jsxs(View, Object.assign({
          style: [priceBreakupItemStyles.rightDetailsItemContainer, (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.marginTop) && {
            marginTop: rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.marginTop
          }]
        }, {
          children: [_jsx(View, Object.assign({
            style: priceBreakupItemStyles.rightDetailsStrikedText
          }, {
            children: !!(rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.strikedText) && _jsx(Typography, Object.assign({
              text: rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.strikedText,
              type: (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.type) ? rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.type : leftRightItemData.rightItemFontType,
              color: (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.strikedTextColor) ? rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.strikedTextColor : leftRightItemData.rightItemColor,
              style: rightTypographyStyle,
              isStriked: !!(rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.strikedText)
            }, getTestId(testID, 'rightTitleStrikedText')))
          })), !!(rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.text) && _jsx(Typography, Object.assign({
            text: rightDetails.text,
            title: rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.title,
            type: (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.type) ? rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.type : leftRightItemData.rightItemFontType,
            color: (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.color) ? rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.color : leftRightItemData.rightItemColor,
            style: rightTypographyStyle
          }, getTestId(testID, 'rightTitleText')))]
        }))]
      })), (multiSubTextList === null || multiSubTextList === void 0 ? void 0 : multiSubTextList.length) > 0 && (multiSubTextList === null || multiSubTextList === void 0 ? void 0 : multiSubTextList.map((item, index) => {
        return _jsx(PriceBreakupItem, Object.assign({}, item, {
          useWrappedText: useWrappedText,
          testID: testID + '_multiSubTextList_' + index.toString(),
          style: priceBreakupItemStyles === null || priceBreakupItemStyles === void 0 ? void 0 : priceBreakupItemStyles.itemSpacing2
        }), "price_breakup_" + index);
      }))]
    }));
  };
  var getDividerContent = showDivider => {
    if (!showDivider) return null;
    return _jsx(Divider, Object.assign({
      height: 2,
      style: priceBreakupItemStyles.divider
    }, getTestId(testID, 'divider')));
  };
  if (showAccordianView) {
    return _jsxs(View, Object.assign({}, restProps, {
      children: [_jsx(Collapsible, Object.assign({
        titleNoHorizontalPadding: true,
        titleNoVerticalPadding: true,
        childNoVerticalPadding: true,
        childNoHorizontalPadding: true,
        titleComponent: getContent(),
        version: "variable-width"
      }, accessibilityProps, collapsibleProps, {
        style: priceBreakupItemStyles.accordianContainerPadding
      }, {
        children: _jsx(View, Object.assign({
          style: priceBreakupItemStyles.accordianContainer
        }, {
          children: accordianList === null || accordianList === void 0 ? void 0 : accordianList.map((item, index) => {
            return _jsx(PriceBreakupItem, Object.assign({}, item, {
              useWrappedText: useWrappedText,
              testID: testID + '_listItem_' + +index.toString(),
              style: !isLastItem(accordianList, index) && priceBreakupItemStyles.itemSpacing
            }), "price_breakup_" + index);
          })
        }))
      })), getDividerContent(showDivider)]
    }));
  }
  return _jsxs(View, Object.assign({}, restProps, {
    children: [getContent(), getDividerContent(showDivider)]
  }));
};